import { render, staticRenderFns } from "./ManagePage.vue?vue&type=template&id=628d12f1&"
import script from "./ManagePage.vue?vue&type=script&lang=js&"
export * from "./ManagePage.vue?vue&type=script&lang=js&"
import style0 from "./ManagePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports